import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchBulkDeallocateCancelSales = ({
  onClick,
  disabled,
  deallocateOnly,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  deallocateOnly: boolean;
}) => {
  return (
    <>
      <PosDropdownItem
        key="deallocate-cancel-sales"
        onClick={onClick}
        disabled={disabled}
      >
        <Stack gap="m" alignItems="center" width="full">
          <span style={{ textAlign: 'left' }}>
            <Content
              id={
                deallocateOnly
                  ? ContentId.DeallocateSales
                  : ContentId.RejectSales
              }
            />
          </span>
        </Stack>
      </PosDropdownItem>
    </>
  );
};
